import React from 'react';
import { ArrowRightIcon, PlayIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative overflow-hidden bg-white pt-16 pb-16 md:pt-24 md:pb-24 lg:pt-32 lg:pb-32" data-id="element-309">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-24" data-id="element-311">
          <div className="w-full lg:w-1/2 space-y-8" data-id="element-312">
            <div className="space-y-5 max-w-xl" data-id="element-313">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-[#5e60ce]" style={{
              backgroundColor: '#f2f1f8'
            }} data-id="element-314">
                For Kit Newsletter Creators
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900" data-id="element-315">
                <span className="text-[#5e60ce]" data-id="element-316">
                  The Amazon Affiliate Tool
                </span>{' '}
                Built For Newsletter Creators
              </h1>
              <p className="text-xl text-gray-500" data-id="element-317">
                Boost your Amazon affiliate revenue with high-converting product
                boxes directly in your newsletter! No programming skills
                required.
              </p>
            </div>
            <div className="flex flex-col space-y-4" data-id="element-318">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-319">
                <a href="https://app.kit.com/apps/1229" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white hover:bg-opacity-90 md:text-lg" style={{
                backgroundColor: '#5e60ce'
              }} target="_blank" rel="noopener noreferrer" data-id="element-320">
                  Install on Kit
                  <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-321" />
                </a>
                <a href="#demo" className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 rounded-md shadow-sm text-base font-medium text-gray-700 bg-white hover:bg-gray-50 md:text-lg" onClick={e => scrollToSection(e, 'demo')} data-id="element-322">
                  <PlayIcon className="mr-2 h-5 w-5" data-id="element-323" />
                  Watch Demo
                </a>
              </div>
              <p className="text-sm font-medium text-[#5e60ce] animate-pulse" data-id="element-324">
                Free for a limited time only
              </p>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-325">
            <div className="relative rounded-xl bg-white shadow-2xl overflow-hidden" data-id="element-326">
              <img src="/Kit-Image-4.jpg" alt="Newsfiliate interface showing Amazon product deals and how they appear in newsletters" className="w-full h-auto object-cover" data-id="element-327" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#5e60ce]/20 to-transparent" data-id="element-328"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}